import React from 'react'
import { H1 } from '@drifthq/tide-core'

import EducationCarousel from 'layouts/EducationCarousel'

import boltTrioPink from './../bolt-trio-pink.svg'

import convoCarouselAsset from './../assets/convo.png'
import clickCarouselAsset from './../assets/click.png'
import shareCarouselAsset from './../assets/share.png'
import notifCarouselAsset from './../assets/notification.png'

import { InstallButton } from './../index'

const poweredByEducationCardList = [
  {
    imgSrc: clickCarouselAsset,
    header: 'Record in one click.',
    copy: 'With embeded chat, viewers can message you directly from your video. Hop right in and say hello!'
  },
  {
    imgSrc: convoCarouselAsset,
    header: 'Start conversations on your videos.',
    copy: 'With embeded chat, viewers can message you directly from your video. Hop right in and say hello!'
  },
  {
    imgSrc: notifCarouselAsset,
    header: 'Get on-the-go video notifications.',
    copy: 'When people watch your video, you can get notified in real-time (on desktop or mobile) so you can follow up at the perfect time.'
  },
  {
    imgSrc: shareCarouselAsset,
    header: 'Share your video anywhere.',
    copy: 'After you record a video, you’ll get a uniqe URL to share your video. Send it via Slack, messaging, email, social - anywhere.'
  },
]

const PoweredByInstallVariant = ({ onInstallClick }) => (
  <div className="drift-getting-started-container">
    <div className="drift-getting-started">
      <div className="drift-install-content">
        <img className="drift-bolt-trio-left" src={boltTrioPink} alt="bolts-pink" />
        <H1 className="drift-getting-started-title">
          Want to make a video like the one you just saw?&nbsp;
          <span>Install the Chrome Extension to record your own videos - it&rsquo;ll take 30 seconds.</span>
        </H1>
        <InstallButton 
          onInstallClick={onInstallClick} 
          copy="Add Drift Video to Chrome" 
        />
      </div>
    </div>
    <EducationCarousel cardList={poweredByEducationCardList} />
  </div>
)

export default PoweredByInstallVariant



// WEBPACK FOOTER //
// ./src/layouts/VideoInstallStep/variants/powered-by-install-component.js